export enum ReportView {
  ACCOUNT_OWNER = 'AccountOwner',
  INDIRECT_ENTERPRICE = 'IndirectEnterprice',
}
